import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash-es';
import { DEALER_PROPS, DEFAULT_REVIEWS_TYPE, REVIEWS_SALES, REVIEWS_SERVICE } from 'client/constants/dealer-reviews';
import { getDealershipWriteReviewLink } from 'site-modules/shared/utils/dealership-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { toSentenceCase } from 'client/utils/string-utils';
import classNames from 'classnames';

export function WriteReviewLinks({ reviewsType = DEFAULT_REVIEWS_TYPE, params, showroomPage = '', classes = '' }) {
  const { dealerState, dealerCity, logicalName } = params;
  const writeReviewLinks = compact([
    [DEFAULT_REVIEWS_TYPE, REVIEWS_SALES].includes(reviewsType) && REVIEWS_SALES,
    [DEFAULT_REVIEWS_TYPE, REVIEWS_SERVICE].includes(reviewsType) && REVIEWS_SERVICE,
  ]).map(type => ({
    url: getDealershipWriteReviewLink({
      state: dealerState,
      city: dealerCity,
      dealership: logicalName,
      reviewType: type,
      showroomPage,
    }),
    title: type,
  }));

  return (
    <div className={classNames('write-review-links medium text-cool-gray-40 text-center', classes)}>
      Write a review:{' '}
      {writeReviewLinks.map(({ url, title }, index) => (
        <Fragment key={`${title}-reviews-link`}>
          {!!index && ' | '}
          <Link className="text-underline" to={url}>
            {toSentenceCase(title)}
          </Link>
        </Fragment>
      ))}
    </div>
  );
}

WriteReviewLinks.propTypes = {
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  showroomPage: PropTypes.string,
  classes: PropTypes.string,
};
